import React from "react";
import { Link } from "react-router-dom";

import INFO from "../../data/user";

import "./styles/logo.css";

const Logo = (props) => {
	let { width, link, style } = props;

	if (link === undefined) {
		link = true;
	}

	const imageElement = (
		<img src={INFO.main.logo} alt="logo" className="logo" style={{width: width+"px"}} />
	);

	return (
		<div className="logo-container-wrapper">
			<div style={style} className="logo-container">
				<React.Fragment>
					{link ? <Link to="/">{imageElement}</Link> : imageElement}
				</React.Fragment>
			</div>
		</div>
	);
};

export default Logo;
